import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { InvoiceEntity } from './invoice.entity';
import { OrderEntity } from './order.entity';

@Entity('tax')
export class TaxEntity extends BaseEntity {
	@Column('varchar', { name: 'label', length: 255 })
	public label!: string;

	@Column('decimal', { name: 'value', nullable: true, precision: 13, scale: 2 })
	public value!: string | null;

	@Column('varchar', { name: 'type', length: 255 })
	public type!: string;

	@Column('varchar', { name: 'code', nullable: true, length: 255 })
	public code!: string | null;

	@OneToMany(() => InvoiceEntity, (invoice) => invoice.fkTax, {})
	public invoices!: Array<InvoiceEntity>;

	@OneToMany(() => OrderEntity, (order) => order.fkTax, {})
	public orders!: Array<OrderEntity>;
}
